import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    closeMenu();
  };

  return (
    <motion.nav
      className={`navbar ${scrolled ? "scrolled" : ""}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="nav-container">
        <motion.div className="nav-logo" whileHover={{ scale: 1.05 }}>
          <h2>Lars & Guro</h2>
        </motion.div>

        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          <li>
            <button
              onClick={() => scrollToSection("home")}
              className="nav-link"
            >
              Hjem
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection("schedule")}
              className="nav-link"
            >
              Program
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection("locations")}
              className="nav-link"
            >
              Steder
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection("rsvp")}
              className="nav-link"
            >
              RSVP
            </button>
          </li>
          <li>
            <a href="/wishlist" className="nav-link nav-anchor" onClick={closeMenu}>
              Ønskeliste
            </a>
          </li>
        </ul>

        <div
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
